export const vms_gen6 = [
  { name: "VM01 Zerschneider", location: "Ruta 7 – Haus vor Santalune City" },
  { name: "VM02 Fliegen", location: "Kalos – nach Arenasieg vom Champ" },
  { name: "VM03 Surfer", location: "Petalburg City – See im Westen" },
  { name: "VM04 Stärke", location: "Fluvia City – Hafenhaus" },
  { name: "VM05 Blitz", location: "Ambrette City – Haus beim Leuchtturm" },
  { name: "VM06 Lehmbrühe", location: "Dendemille City – Pokémon Center NPC" },
  { name: "VM07 Gebirge", location: "Flussgrabenklamm – im Inneren" }
];